import { type FlowNode, TriggerNodeType, type WebhookTriggerConfigure } from '@lighthouse/shared'

const WEBHOOK_URL_TEMPLATE = 'testapp.byecode.com/{apiKey}'

export function buildWebhookUrl(apiKey: string) {
    return WEBHOOK_URL_TEMPLATE.replace('{apiKey}', apiKey)
}

export function resolveWebhookNodes(nodes: FlowNode[], apiKey?: string): FlowNode[] {
    const token = apiKey?.trim()
    if (!token) {
        return nodes
    }
    return nodes.map(node => {
        if (node.data.nodeType !== TriggerNodeType.WEBHOOK_TRIGGER) {
            return node
        }
        const data = node.data as WebhookTriggerConfigure
        const url = data.config?.url
        if (!url?.includes('{apiKey}')) {
            return node
        }
        return {
            ...node,
            data: {
                ...data,
                config: {
                    ...data.config,
                    url: url.replaceAll('{apiKey}', token)
                }
            }
        } as FlowNode
    })
}
